import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'

import { LayoutAuth } from 'Components/Layout/Auth'
import { BackgroundLogo } from 'Components/Sidebar/BackgroundLogo'
import { ResetPasswordForm } from 'Containers/Form/ResetPassword'
import {
  checkCodeAndHashValidForResettingPassword,
  resetPassword,
} from 'Reducers/Auth/actions'
import { PATHS } from 'Config/Routing/paths'
const queryString = require('query-string')

class ResetPassword extends Component {
  /**
   * Before component is mounted
   */
  componentDidMount() {
    const params = queryString.parse(this.props.location.search)

    this.props.checkCodeAndHashValidForResettingPassword(
      params.hash,
      params.code,
    )
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formSubmitted) {
      nextProps.history.push(PATHS.main.login)
    }
  }

  /**
   * Render component
   *
   * @returns XML
   */
  render() {
    return (
      <LayoutAuth>
        <Col xs={12} md={6}>
          <BackgroundLogo />
        </Col>
        <Col xs={12} md={6}>
          <ResetPasswordForm
            formSubmitting={this.props.formSubmitting}
            errorMessage={this.props.errorMessage}
            isCodeAndHashValid={this.props.isCodeAndHashValid}
            onSubmit={this.onSubmit}
          />
        </Col>
      </LayoutAuth>
    )
  }

  /**
   * Submit form (reset password)
   *
   * @param values
   */
  onSubmit = values => {
    const params = queryString.parse(this.props.location.search)
    this.props.resetPassword(params.hash, params.code, values.password)
  }
}

const mapStateToProps = state => ({
  formSubmitting: state.auth.formSubmitting,
  formSubmitted: state.auth.formSubmitted,
  errorMessage: state.auth.errorMessage,
  isCodeAndHashValid: state.auth.isCodeAndHashValid,
})

export default connect(
  mapStateToProps,
  {
    checkCodeAndHashValidForResettingPassword,
    resetPassword,
  },
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/Containers/Auth/ResetPassword/index.js